import { observable, action } from 'mobx';
import agent from '../services/web/agent';
import userSharedFormsValidator from '../services/validations/userSharedFormsValidator';
import ConfigurationsStore from './configurationsStore';
class ForgotPasswordStore {

  @observable errors = null;
  @observable isError = null;
  @observable errorMessage = null;
  @observable inProgress = false;
  @observable userNameValidationMessage;
  @observable tenantValidationMessage;

  formErrors = [];

  @observable values = {
    userName: '',
    tenant: '',
  };


  @action setUserName(userName) {
    this.values.userName = userName.trim();
  }

  @action setTenant(tenant) {
    this.values.tenant = tenant;
  }

  @action reset() {
    this.values.userName = '';    
    this.values.tenant = '';    
  }

  @action validateForm() { 

    this.formErrors = [];
    this.validateUserName();
    ConfigurationsStore.isMultitenancyMode && this.validateTenant();
    
    if (this.formErrors.filter((valid) => valid > 0).length > 0) {
        return false;   
    }

    return true;
}

  validateUserName() {

    const validation = userSharedFormsValidator.validateUserName(this.values.userName);

    this.userNameValidationMessage = validation.errors.first('userName');

    this.formErrors.push(validation.errorCount);
  }
  
  validateTenant() {

    const validation = userSharedFormsValidator.validateGenericRequiredField(this.values.tenant);

    this.tenantValidationMessage = validation.errors.first('field');

    this.formErrors.push(validation.errorCount);
  }

  
  @action forgotPassword() {
    
    this.inProgress = true;
       
    return agent.Users.forgotPassword(this.values.userName, this.values.tenant)
    .catch(action((err) => {

        this.inProgress = false; 

        if (err && err.response && err.response.text) {
    
          this.isError = true;
          this.errorMessage = JSON.parse(err.response.text).Message;
        }

        this.errors = err.response && err.response.body && err.response.body.errors;
        throw err;

      }))
      .finally(action(() => { 
          this.inProgress = false; 
      }));
  }
  
}

export default new ForgotPasswordStore();